import {AfterViewInit, Component, OnDestroy, ViewChild} from '@angular/core';
import {InsuranceCompany} from '../../../shared/interface/insurance-company';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {InsuranceCompanyService} from '../../../shared/services/insurance-company.service';
import {delay, distinctUntilChanged, takeUntil} from 'rxjs/operators';
import {CountedAndPaginated} from '../../../shared/interface/response/counted-and-paginated';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FilterService} from '../../../shared/services/filter.service';
import {select, Store} from '@ngrx/store';
import {StoreRootState} from '../../../shared/ngrx/reducers';
import {getCurrentRouteState} from '../../../shared/ngrx/selector';
import {RouterStateUrl} from '../../../shared/ngrx/route-serializer';

@Component({
  selector: 'app-all-insurance-companies-list',
  templateUrl: './all-insurance-companies-list.component.html',
  styleUrls: ['./all-insurance-companies-list.component.scss']
})
export class AllInsuranceCompaniesListComponent implements AfterViewInit, OnDestroy {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  initialFilters: any;
  insuranceCompanies: InsuranceCompany[] = [];
  displayedColumns: string[] = ['logo', 'name', 'fullName', 'type', 'companies', 'blocked', 'inactive'];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private insuranceCompanyService: InsuranceCompanyService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private filterService: FilterService,
    private store: Store<StoreRootState>,
    private router: Router,
  ) {
    this.insuranceCompanyService.getInsuranceCompaniesPageSubject()
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((resp: CountedAndPaginated<InsuranceCompany>) => {
        this.insuranceCompanies = resp.items;
        this.totalData = resp.pagination.total;
    });
    this.userPermissions = authService.getUserPermissions();
    this.parseFilters();
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      contains$name: 'string',
      contains$fullName: 'string',
      type: 'int',
      company: 'int',
      blockRegistrations: 'int',
      inactive: 'int',

    }, filters);
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
          page: event.pageIndex,
          pageSize: event.pageSize,
          ...this.filtersForm.value
        })]);
      });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }

  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  downloadReport(): void {
    this.insuranceCompanyService.downloadReport(this.initialFilters);
  }

  loadListData(): void {
    this.insuranceCompanyService.loadList(this.paginator.pageIndex, this.paginator.pageSize, this.initialFilters);
  }

  resetFilters(): void {
    this.filtersForm.resetForm({});
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }
}
